export default __webpack_public_path__ + "static/media/blue.04ec2561.svg";